// extracted by mini-css-extract-plugin
export default {"kyc":"Kyc_kyc__drlSa","box":"Kyc_box__qgHTV","info":"Kyc_info__TDPE6","infoApproved":"Kyc_infoApproved__nySsS","button":"Kyc_button__6XKbC","date":"Kyc_date__XPNQD"};